import "./Home.module.css";
import Encabezado from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import SobreNosotros from "./sections/SobreNosotros";
import NuestroMenu from "./sections/NuestroMenu";
import CartaDeVinos from "./sections/CartaDeVinos";
import Testimonios from "./sections/Testimonios";
import ContactoYReserva from "./sections/ContactoYReserva";
import PieDePágina from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Encabezado />
      <Hero />
      <SobreNosotros />
      <NuestroMenu />
      <CartaDeVinos />
      <Testimonios />
      <ContactoYReserva />
      <PieDePágina />
    </div>;
}